import ListingActivationConstants from 'app/shared/constants/ListingActivationConstants';

const listingActivationUtils = {
    isFailedActivationErrorCode(code) {
        return Object.values(ListingActivationConstants.ERROR_CODE).includes(code);
    },
};

export default listingActivationUtils;
